import { api } from './client.js';

export const analyzeVisibleLayers = (payload) => api.post('/ai/analyze', payload);
